import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const EmptyCard = () => {
  return (
    <Box
      alignItems="center"
      justifyContent="center"
      borderRadius={{ all: 'abs008' }}
      paddingY="s24"
      border={{
        all: {
          width: 's1',
          color: 'grey400',
          style: 'solid',
        },
      }}
    >
      <Text size="200">{i18n.t('break_types.empty')}</Text>
    </Box>
  )
}

export default EmptyCard
